export default __webpack_public_path__ + "static/media/pexels-alesia-kozik-6770845-min-min.d3d245bf.jpg";